import apiService from '@/services/apiService';
import {API_GET_LIST_REPORT_LAYOUT} from '@/configs/api';

const getDefaultState = () => {
  return {
    listConstructionSite: [],
    listConstructionSiteSelected: [],
    constructionSelected: {},
    constructionSiteSelected: {},
    listLayout: [],
    layoutSelected: null,
    reportCover: {}
  }
};
const state = getDefaultState();

const mutations = {
  SET_LIST_CONSTRUCTION_SITE (state, payload) {
    state.listConstructionSite = payload;
  },
  SET_LIST_CONSTRUCTION_SITE_SELECTED (state, payload) {
    state.listConstructionSiteSelected = payload;
  },
  SET_LIST_LAYOUT (state, payload) {
    state.listLayout = payload;
  },
  SET_LAYOUT_SELECTED (state, payload) {
    state.layoutSelected = payload;
  },
  SET_CONSTRUCTION_SELECTED (state, payload) {
    state.constructionSelected = payload;
  },
  SET_CONSTRUCTION_SITE_SELECTED (state, payload) {
    state.constructionSiteSelected = payload;
  },
  SET_REPORT_COVER (state, payload) {
    state.reportCover = payload
  },
  RESET_CREATE_REPORT (state, payload) {
    state.listConstructionSite = [];
    state.listConstructionSiteSelected = [];
    state.constructionSelected = {};
    state.listLayout = [];
    state.layoutSelected = null;
    state.reportCover = {};
  }
};

const actions = {
  async getListConstructionSite ({commit, dispatch}, payload) {
    const result = await apiService.postWithoutIsCallingFlag(payload.url, payload.params)
    if (result.data.construction) {
      commit('SET_CONSTRUCTION_SELECTED', result.data.construction)
    }
    commit('SET_LIST_CONSTRUCTION_SITE', result.data.construction_site_list);
    if (result.data.user_info) {
      commit('SET_USER_INFO', result.data.user_info, { root: true });
    }
    if (result.data.ver) {
      commit('SET_APP_VERSION', result.data.ver, { root: true });
      await dispatch('checkAppVersion', {}, {root: true});
    }

    return result.data.code;
  },
  async getListLayout ({commit}, payload) {
    const result = await apiService.postWithoutIsCallingFlag(API_GET_LIST_REPORT_LAYOUT, payload.params)
    commit('SET_LIST_LAYOUT', result.data.layout_list);
    return result.data.code;
  },
  async makeReport ({commit}, payload) {
    let retry = 0
    if (payload.params && payload.params.finish_flag) {
      retry = 3
    }

    let url = payload.params.apiUrl
    delete payload.params.apiUrl

    const result = await apiService.postWithAuthentication(url, payload.params, {
      showLoading: false,
      retry: retry
    })
    return result;
  },
  async setReportCover ({commit}, payload) {
    commit('SET_REPORT_COVER', payload)
  }
};

export default {
  state, mutations, actions
};



// WEBPACK FOOTER //
// ./src/stores/modules/reportStore.js